// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"e4a7d631","118":"ca6fd64b","159":"23574d85","251":"851eab57","328":"8bbcbbd6","416":"b5dd2ddf","451":"03dcb653","460":"62e1646a","502":"bde7b983","528":"920e9261","587":"b05320f6","631":"16eef09a","742":"60039efb","744":"ec53bdea","832":"2165c8e7"}[chunkId] + ".chunk.js";
};